// เครื่องที่ยังไม่เลือกโหมด (unassigned) ห้ามเข้า dashboard (ใบเสร็จ / ปิดร้าน / payments)
// → พาไป /select-run-mode
//
// ของเดิม (beta) กันไว้ที่หน้า /pos หน้าเดียว (modules/pos/pages/index.vue) เครื่องที่ยัง
// ไม่เลือกโหมดจึงเปิด /dashboard ดูใบเสร็จ / ปิดร้าน ได้ตรง ๆ
//
// หน้าอื่น (รายงาน, เมนู, ตั้งค่า ฯลฯ) ยังเข้าได้เหมือนเดิม — บางบัญชี login มาดูรายงานอย่างเดียว
// ไม่ต้องบังคับเลือกโหมดก่อน ปุ่มแดชบอร์ดในแถบซ้ายก็ซ่อนไว้ (layouts/default.vue)
//
// ลงทะเบียนเป็น global route middleware ใน modules/seat/index.ts
import { RunMode } from "../../../interface/Pos";
import { getResolvedStoreId } from "../../core/composables/useStoreIdentity";
import { useRunningMode } from "../../core/composables/useRunningMode";

/** หน้าที่ต้องเลือกโหมดก่อนถึงจะเข้าได้ */
const GUARDED_PREFIXES = ["/dashboard"];

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;
  if (!GUARDED_PREFIXES.some((prefix) => to.path.startsWith(prefix))) return;

  // ยังไม่รู้ร้าน (ยังไม่ login / ยัง boot ไม่เสร็จ) — ให้ auth / bootstrap จัดการก่อน
  if (!getResolvedStoreId()) return;

  if (useRunningMode().getMode() !== RunMode.UNASSIGNED) return;
  return navigateTo("/select-run-mode");
});
